import { useUser } from "@auth";
import { createThirdPartyRefund } from "@api";
import {
  Button,
  CurrencyInput,
  FormError,
  FormGroup,
  FormLabel,
  Modal
} from "@components";
import { useState } from "react";
import { CheckLg } from "react-bootstrap-icons";
import { useForm } from 'react-hook-form';

const IssueKlarnaRefund = ({ onComplete, paymentId, amountPaid, amountRefunded, customerName, isOpen, onClose, isRefundAllowed }) => {
  const { user } = useUser();
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [apiError, setApiError] = useState("");

  const { control, handleSubmit, watch, reset, formState: { errors }, clearErrors } = useForm({
    defaultValues: {
      amountPaid: amountPaid,
      amountRefunded: amountRefunded || 0,
      // Deliberately not prefilled with the refundable amount — users were
      // accidentally issuing full refunds by clicking straight through.
      amount: 0,
    }
  });


  async function onSubmit(formData) {
    setLoading(true);

    try {
      setApiError("");
      const data = await createThirdPartyRefund(paymentId, formData.amount);

      setSubmitted(formData);
      setLoading(false);
  
      if (onComplete) {
        await onComplete();
      }
    } catch (error) {
      setLoading(false);
      setApiError("Error occurred, please try again later.");
    }
    
  }

  const close = () => {
    onClose();
    reset({
      amount: 0,
    });
    setTimeout(() => setSubmitted(null), 200);
    ;
  }

  return (<Modal isOpen={isOpen} onClose={close} title="Issue refund">
    {submitted
      ? <>
        <div className="bg-emerald-50 rounded-full size-16 flex items-center justify-center mx-auto mb-5">
          <CheckLg className="text-emerald-900" size={24} />
        </div>
        <h5 className="mb-5 font-semibold text-center">Refund successful</h5>
        <p className="mb-5 text-sm text-zinc-500 text-center px-5">Your refund to {customerName} has been initiated successfully. The customer should receive funds back via Klarna.</p>
      </>
      : (isRefundAllowed ? <form onSubmit={handleSubmit(onSubmit)} className="mt-4 px-5">
        <FormGroup>
          <FormLabel>Amount paid</FormLabel>
          <CurrencyInput
            name="amountPaid"
            control={control}
            disabled={true} />
        </FormGroup>
        <FormGroup>
          <FormLabel>Previous refunds</FormLabel>
          <CurrencyInput
            name="amountRefunded"
            control={control}
            disabled={true} />
        </FormGroup>
        <FormGroup>
          <FormLabel>Refund amount</FormLabel>
          <CurrencyInput
            name="amount"
            control={control}
            displayName="Amount"
            max={amountPaid - amountRefunded}
            validate={(v) =>
              parseFloat(v) > 0 || "Enter a refund amount greater than £0.00"
            } />
          <FormError name="amount" errors={errors} />
        </FormGroup>

        {apiError && (
          <p className="text-red-600 text-sm px-5 mt-2 mb-1">
            {apiError}
          </p>
        )}

      </form> : <p className="mt-4 px-5 text-sm">This payment cannot be refunded directly, as it was made to an account that does not support refunds. We recommend issuing a credit note to the customer's account or returning the funds via BACS transfer.</p>)}
    {!submitted ? <div className="flex gap-2 justify-end px-5 py-4">
      <Button
        color="secondary"
        disabled={loading}
        onClick={() => close()}
      >
        Cancel
      </Button>
      {isRefundAllowed && <Button
        color="primary"
        type="submit"
        disabled={loading}
        onClick={handleSubmit(onSubmit)}
      >
        Issue refund
      </Button>}</div>
      : <div className="flex gap-2 justify-end px-5 py-4"><Button
        color="primary"
        className="w-full"
        type="submit"
        onClick={() => close()}
      >
        Return to dashboard
      </Button></div>}
  </Modal>);
}

export default IssueKlarnaRefund;
